export enum LicenseStatus {
  ACTIVE = 'Active',
  NOT_ASSIGNED = 'Not Assigned',
  NOT_ACTIVATED = 'Not Activated',
  IN_PROGRESS = 'In Progress',
}
